<script>
import Autocomplete from '@/components/Autocomplete'
import elasticlunr from 'elasticlunr'
import { map, each, find, filter, sortBy, indexOf, isArray, get, merge } from 'lodash'

let strategies = []

let SOURCE_SOI = 'Sphere-of-Influence (SOI)'
let SOURCE_OPEN_HOUSE = 'Open Houses'
let SOURCE_GEO_FARM = 'Geo-Farming'
let SOURCE_ONLINE_LEADS = 'Online Leads'
let SOURCE_VIDEO = 'Video'
let SOURCE_SOCIAL_MEDIA = 'Social Media'
let SOURCE_NICHE = 'Niche Marketing'
let SOURCE_COLD_CALLING = 'Cold "Infinite Lead Source" Calling'
let SOURCE_COMPANY = 'Company'
let SOURCE_AGENT_TO_AGENT = 'Agent-to-Agent'

let FREQ_DAILY = 'Daily'
let FREQ_WEEKLY = 'Weekly'
let FREQ_MONTHLY = 'Monthly'
let FREQ_QUARTERLY = 'Quarterly'
let FREQ_ANNUALLY = 'Annually'
let FREQ_BIANNUALLY = '2x Year'

let TYPE_PROSPECTING = 'Prospecting'
let TYPE_ADVERTISING = 'Advertising'
let TYPE_HOSTING = 'Hosting'
let TYPE_PUBLISHING = 'Publishing'
let TYPE_PURCHASING = 'Purchasing'
let TYPE_NETWORKING = 'Networking'

let s = (name, type, source, freq, aliases) => strategies.push(
  merge(
    {
      default_frequency: FREQ_MONTHLY,
      aliases: '',
    },
    {
      name,
      type,
      source: isArray(source) ? source : [source],
      default_frequency: freq,
      aliases,
    },
    {
      id: strategies.length + 1,
    }
  )
)

// s(
//   'Annual CMA Delivery',
//   TYPE_ADVERTISING,
//   [SOURCE_SOI, SOURCE_GEO_FARM],
//   FREQ_MONTHLY
// )

s(
  'Client Appreciation Event',
  TYPE_HOSTING,
  [SOURCE_SOI],
  FREQ_BIANNUALLY
)

s(
  'Preferred Client Club/ American Lifestyle',
  TYPE_HOSTING,
  [SOURCE_SOI],
  FREQ_ANNUALLY
)

s(
  'Home Equity Review',
  TYPE_PROSPECTING,
  [SOURCE_SOI],
  FREQ_ANNUALLY
)

// s(
//   'Daily Call List in Redwood CRM App',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI, SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA, SOURCE_NICHE, SOURCE_COLD_CALLING],
//   FREQ_DAILY
// )

s(
  'Monthly Newsletter',
  TYPE_PUBLISHING,
  [SOURCE_SOI, SOURCE_NICHE],
  FREQ_MONTHLY
)

s(
  'Pop-Bys',
  TYPE_PROSPECTING,
  [SOURCE_SOI],
  FREQ_QUARTERLY
)

s(
  'Quarterly Conversations',
  TYPE_PROSPECTING,
  [SOURCE_SOI],
  FREQ_QUARTERLY
)

s(
  'SOI Postcards',
  TYPE_ADVERTISING,
  [SOURCE_SOI],
  FREQ_QUARTERLY,
)

s(
  'Geo-Farm Postcards',
  TYPE_ADVERTISING,
  [SOURCE_GEO_FARM],
  FREQ_QUARTERLY,
)

s(
  'Open House Postcards',
  TYPE_ADVERTISING,
  [SOURCE_OPEN_HOUSE],
  FREQ_QUARTERLY,
)

s(
  'Open House Social Video Post',
  TYPE_ADVERTISING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY,
)

s(
  'Batch Recorded Reels',
  TYPE_PUBLISHING,
  [SOURCE_VIDEO],
  FREQ_MONTHLY
)

// s(
//   'Automated Marketing (ex. PCC)',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI],
//   FREQ_MONTHLY,
// )

s(
  'AI Boost Branding Ad',
  TYPE_ADVERTISING,
  [SOURCE_SOI, SOURCE_GEO_FARM, SOURCE_SOCIAL_MEDIA],
  FREQ_MONTHLY
)

// s(
//   'Chirp Campaign',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI, SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_VIDEO, SOURCE_ONLINE_LEADS, SOURCE_NICHE],
//   FREQ_MONTHLY
// )

s(
  'Event Sponsorship',
  TYPE_PURCHASING,
  [SOURCE_NICHE],
  FREQ_ANNUALLY
)

// s(
//   'Volunteer',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI, SOURCE_GEO_FARM, SOURCE_NICHE],
//   FREQ_ANNUALLY
// )

s(
  'Local Content Blog Post',
  TYPE_PUBLISHING,
  [SOURCE_GEO_FARM],
  FREQ_WEEKLY,
)

s(
  'Local Content Video',
  TYPE_PUBLISHING,
  [SOURCE_GEO_FARM, SOURCE_VIDEO],
  FREQ_WEEKLY
)

// s(
//   'Top Homes Blog Post',
//   TYPE_PUBLISHING,
//   [SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA],
//   FREQ_WEEKLY
// )

// s(
//   'Facebook/ Instagram Video Tour',
//   TYPE_PUBLISHING,
//   [SOURCE_OPEN_HOUSE, SOURCE_SOI, SOURCE_GEO_FARM, SOURCE_VIDEO, SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA],
//   FREQ_WEEKLY
// )

s(
  'Text Campaign',
  TYPE_PROSPECTING,
  [SOURCE_SOI],
  FREQ_MONTHLY
)

s(
  'Comment/ Share Posts',
  TYPE_PROSPECTING,
  [SOURCE_SOI, SOURCE_SOCIAL_MEDIA],
  FREQ_QUARTERLY
)

s(
  'Personal Letter (Postal Service)',
  TYPE_ADVERTISING,
  [SOURCE_SOI],
  FREQ_BIANNUALLY
)

s(
  'CRM Campaign',
  TYPE_PROSPECTING,
  [SOURCE_SOI, SOURCE_ONLINE_LEADS],
  FREQ_MONTHLY
)

s(
  'Open House CRM Campaign',
  TYPE_PROSPECTING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

s(
  'Social Post',
  TYPE_PUBLISHING,
  [SOURCE_SOCIAL_MEDIA],
  FREQ_DAILY
)

s(
  'Social Posts/ Stories',
  TYPE_PUBLISHING,
  [SOURCE_SOI, SOURCE_SOCIAL_MEDIA],
  FREQ_DAILY
)

s(
  'Stories (Daily)',
  TYPE_PUBLISHING,
  [SOURCE_SOCIAL_MEDIA],
  FREQ_DAILY
)

// s(
//   'Thank You Cards',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI, SOURCE_OPEN_HOUSE],
//   FREQ_MONTHLY
// )

// s(
//   'Virtual Pop-By',
//   TYPE_PROSPECTING,
//   [SOURCE_SOI, SOURCE_SOCIAL_MEDIA],
//   FREQ_QUARTERLY
// )

// s(
//   'Professional Listing for Every Listing',
//   TYPE_ADVERTISING,
//   [SOURCE_SOI, SOURCE_GEO_FARM, SOURCE_VIDEO, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

// s(
//   'Core Voicemail Drop',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_ONLINE_LEADS],
//   FREQ_MONTHLY
// )

// s(
//   'For Sale/ Directional Signs',
//   TYPE_ADVERTISING,
//   [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM],
//   FREQ_MONTHLY
// )

s(
  'Door Hangers',
  TYPE_ADVERTISING,
  [SOURCE_GEO_FARM],
  FREQ_MONTHLY
)

s(
  'Open House Door Hangers',
  TYPE_ADVERTISING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

s(
  'Open House',
  TYPE_PROSPECTING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

s(
  'Short Form (Vertical) Video',
  TYPE_PUBLISHING,
  [SOURCE_VIDEO, SOURCE_ONLINE_LEADS],
  FREQ_WEEKLY
)

s(
  'Long Form (Horizontal) Video',
  TYPE_PUBLISHING,
  [SOURCE_VIDEO, SOURCE_ONLINE_LEADS],
  FREQ_MONTHLY
)

s(
  'Reel/ YT Short (Vertical)',
  TYPE_PUBLISHING,
  [SOURCE_VIDEO, SOURCE_ONLINE_LEADS],
  FREQ_WEEKLY
)

// s(
//   'Enter Open House in MLS',
//   TYPE_ADVERTISING,
//   [SOURCE_OPEN_HOUSE],
//   FREQ_MONTHLY
// )

s(
  'Facebook Event',
  TYPE_ADVERTISING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

s(
  'Neighbors Only Open House',
  TYPE_HOSTING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

// s(
//   'Redwood Open House App',
//   TYPE_HOSTING,
//   [SOURCE_OPEN_HOUSE],
//   FREQ_MONTHLY
// )

s(
  'Facebook/ Instagram Live',
  TYPE_PUBLISHING,
  [SOURCE_OPEN_HOUSE, SOURCE_SOCIAL_MEDIA],
  FREQ_MONTHLY
)

s(
  'Open House AI Boost Ad',
  TYPE_ADVERTISING,
  [SOURCE_OPEN_HOUSE],
  FREQ_MONTHLY
)

// s(
//   '5-5-10 Door Knocking',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_COLD_CALLING],
//   FREQ_MONTHLY,
// )

s(
  'Door Knocking',
  TYPE_PROSPECTING,
  [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_COLD_CALLING],
  FREQ_MONTHLY,
)

// s(
//   'Boosted Facebook/ Instagram Post',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

s(
  'Circle Prospecting',
  TYPE_PROSPECTING,
  [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_COLD_CALLING],
  FREQ_WEEKLY
)

// s(
//   'Circle Prospecting With Dialer (e.g., Vulkan7)',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_COLD_CALLING],
//   FREQ_WEEKLY
// )

// s(
//   'Food Truck Open House',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE],
//   FREQ_QUARTERLY
// )

// s(
//   'Prize Drawing at Open House',
//   TYPE_PURCHASING,
//   [SOURCE_OPEN_HOUSE],
//   FREQ_MONTHLY
// )

// s(
//   'Promoted Video Post on Social',
//   TYPE_ADVERTISING,
//   [SOURCE_OPEN_HOUSE, SOURCE_VIDEO, SOURCE_ONLINE_LEADS],
//   FREQ_MONTHLY
// )

// s(
//   'Share New Listings + Status Changes on Social',
//   TYPE_PROSPECTING,
//   [SOURCE_OPEN_HOUSE, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

// s(
//   'Targeted Social Ad',
//   TYPE_ADVERTISING,
//   [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

s(
  'Mega Open House',
  TYPE_PROSPECTING,
  [SOURCE_OPEN_HOUSE, SOURCE_GEO_FARM],
  FREQ_QUARTERLY
)

// s(
//   'Promote Property Website For Every Listing',
//   TYPE_ADVERTISING,
//   [SOURCE_GEO_FARM],
//   FREQ_MONTHLY
// )

s(
  'Market Stats Video Post',
  TYPE_PROSPECTING,
  [SOURCE_GEO_FARM],
  FREQ_MONTHLY
)

s(
  'Neighborhood Meetings/ Events',
  TYPE_HOSTING,
  [SOURCE_GEO_FARM],
  FREQ_QUARTERLY
)

s(
  'AI Boost Listing Ad',
  TYPE_ADVERTISING,
  [SOURCE_ONLINE_LEADS],
  FREQ_MONTHLY
)

s(
  'Expired/ FSBOs',
  TYPE_PROSPECTING,
  [SOURCE_COLD_CALLING, SOURCE_GEO_FARM],
  FREQ_MONTHLY
)

s(
  'Expired Prospecting',
  TYPE_PROSPECTING,
  [SOURCE_COLD_CALLING, SOURCE_GEO_FARM],
  FREQ_MONTHLY
)

s(
  'FSBO Prospecting',
  TYPE_PROSPECTING,
  [SOURCE_COLD_CALLING],
  FREQ_MONTHLY
)

s(
  "Home Value Ad",
  TYPE_ADVERTISING,
  [SOURCE_GEO_FARM],
  FREQ_MONTHLY
)

s(
  'Video Messages',
  TYPE_PROSPECTING,
  [SOURCE_VIDEO],
  FREQ_MONTHLY
)

// s(
//   'Use Redwood CRM Automated Response',
//   TYPE_PROSPECTING,
//   [SOURCE_ONLINE_LEADS],
//   FREQ_MONTHLY
// )

// s(
//   'Automated Marketing, e.g., Core Multichannel',
//   TYPE_ADVERTISING,
//   [SOURCE_ONLINE_LEADS],
//   FREQ_MONTHLY
// )

// s(
//   'Contact New Leads Immediately',
//   TYPE_PROSPECTING,
//   [SOURCE_ONLINE_LEADS],
//   FREQ_DAILY
// )

s(
  'Old Leads',
  TYPE_PROSPECTING,
  [SOURCE_COLD_CALLING],
  FREQ_MONTHLY
)

s(
  'Zip Code Advertising',
  TYPE_PROSPECTING,
  [SOURCE_ONLINE_LEADS],
  FREQ_MONTHLY
)

// s(
//   'Top Homes Blog Post',
//   TYPE_PUBLISHING,
//   [SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA],
//   FREQ_WEEKLY
// )

s(
  'Listing Video',
  TYPE_ADVERTISING,
  [SOURCE_VIDEO],
  FREQ_MONTHLY
)

// s(
//   'Personalized Video Touches (Core Video)',
//   TYPE_PROSPECTING,
//   [SOURCE_VIDEO, SOURCE_SOI],
//   FREQ_QUARTERLY
// )

// s(
//   'Send Video Using Redwood CRM Landing Page',
//   TYPE_PUBLISHING,
//   [SOURCE_VIDEO, SOURCE_ONLINE_LEADS],
//   FREQ_QUARTERLY
// )

s(
  'YouTube Channel',
  TYPE_PUBLISHING,
  [SOURCE_VIDEO],
  FREQ_MONTHLY
)

// s(
//   'TikTok',
//   TYPE_PUBLISHING,
//   [SOURCE_ONLINE_LEADS, SOURCE_VIDEO],
//   FREQ_DAILY
// )

// s(
//   'Social Engagement Post',
//   TYPE_PUBLISHING,
//   [SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

// s(
//   'Top 10 List Social Post',
//   TYPE_PUBLISHING,
//   [SOURCE_ONLINE_LEADS, SOURCE_SOCIAL_MEDIA],
//   FREQ_MONTHLY
// )

s(
  'Niche Networking',
  TYPE_PROSPECTING,
  [SOURCE_NICHE],
  FREQ_MONTHLY
)

s(
  'Niche Focused Video (Horizontal)',
  TYPE_PROSPECTING,
  [SOURCE_NICHE, SOURCE_VIDEO],
  FREQ_MONTHLY
)

s(
  'Niche Focused Reel (Vertical)',
  TYPE_PROSPECTING,
  [SOURCE_NICHE, SOURCE_VIDEO],
  FREQ_WEEKLY
)

s(
  'Niche Focused Social Post',
  TYPE_PROSPECTING,
  [SOURCE_NICHE],
  FREQ_WEEKLY
)

s(
  'Niche Focused Blog Post',
  TYPE_PROSPECTING,
  [SOURCE_NICHE],
  FREQ_WEEKLY
)

s(
  'Saved Home Search',
  TYPE_PROSPECTING,
  [SOURCE_ONLINE_LEADS],
  FREQ_WEEKLY
)

s(
  'Google PPC Campaign',
  TYPE_ADVERTISING,
  [SOURCE_ONLINE_LEADS],
  FREQ_WEEKLY,
)

s(
  'Facebook/ Instagram Lead Campaign',
  TYPE_ADVERTISING,
  [SOURCE_ONLINE_LEADS],
  FREQ_WEEKLY,
)

s(
  'Reel/ YouTube Short',
  TYPE_ADVERTISING,
  [SOURCE_ONLINE_LEADS, SOURCE_VIDEO],
  FREQ_WEEKLY,
)

strategies = sortBy(strategies, ['name'])

export default {
  extends: Autocomplete,
  props: {
    searchOnFocus: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    search: {
      type: Function,
      default: function (query) {
        let promise = new Promise((resolve, reject) => {


          let data = {}
          if (query.search) {
            let results = this.index.search(query.search, {
              fields: {
                name: {
                  boost: 2,
                  expand: true
                },
                aliases: {
                  boost: 1,
                  expand: true
                }
              }
            })
            data = map(results, (result) => {
              return find(this.strategies, {id: parseInt(result.ref)})
            })
          } else {
            data = this.strategies.slice(0)
          }
          resolve({ data })
        })
        return promise
      }
    }
  },
  data () {
    return {
      strategies: [],
      index: null
    }
  },
  computed: {
    showNotFoundError () {
      return false
    }
  },
  watch: {
    source () {
      this.updateStrategies()
    },
    type () {
      this.updateStrategies()
    }
  },
  mounted () {
    this.updateStrategies()
  },
  methods: {
    updateStrategies () {
      this.strategies = filter(strategies, (strategy) => {
        if (this.source && indexOf(strategy.source, this.source) === -1) {
          return false
        }
        /*
        if (this.type && indexOf(strategy.type, this.type) === -1) {
          return false
        }
         */
        return true
      })

      this.index = elasticlunr(function () {
        this.addField('name')
        this.addField('aliases')
        this.setRef('id')
      })

      each(this.strategies, (strategy) => {
        this.index.addDoc(strategy)
      })
    },
    onBlur () {
      setTimeout(() => {
        this.searching = this.searched = false
        if (!this.selected) {
          if (this.query) {
            this.select({
              name: this.query,
              default_frequency: get(this.value, 'default_frequency') || 'Daily'
            })
          }
          this.query = ''
        }
      }, 200)
    }
  }
}
</script>